// 허브 subcategory 로컬 fallback — src/data/hubSubcategoryCatalog.js 와 DB 동기화

import {
  HUB_SUBCATEGORY_LABELS_FROM_CATALOG,
  HUB_SUBCATEGORY_CATALOG,
  getHubSubcategoryOrder,
} from '../data/hubSubcategoryCatalog';

export const HUB_SUBCATEGORY_LABELS = {
  ...HUB_SUBCATEGORY_LABELS_FROM_CATALOG,
  meal_kit: { ko: '밀키트·도시락', en: 'Meal Kit' },
};

/**
 * @param {string} key
 * @param {string} [lang] 'ko' | 'en' | 'vi' | 'ru'
 */
export function getSubcategoryLabel(key, lang = 'ko') {
  const item = HUB_SUBCATEGORY_LABELS[key];
  if (!item) return key;
  return item[lang] || item.en || item.ko || key;
}

/**
 * @param {string} category
 * @param {string} key
 * @param {string} [lang]
 * @param {Array<{ key: string, label_ko?: string, label_en?: string, label_vi?: string, label_ru?: string }>} [masterRows]
 */
export function resolveSubcategoryLabel(category, key, lang = 'ko', masterRows = []) {
  void category;
  const row = masterRows.find((r) => r.key === key);
  if (row) {
    const langField = row[`label_${lang}`] || row[`label_${String(lang).replace('-', '_')}`];
    if (typeof langField === 'string' && langField.trim()) return langField.trim();
  }
  const fromCatalog = getSubcategoryLabel(key, lang);
  if (fromCatalog && fromCatalog !== key) return fromCatalog;
  if (row && typeof row.label_ko === 'string' && row.label_ko.trim()) return row.label_ko.trim();
  return key;
}

const HUB_CATEGORY_IDS = Object.keys(HUB_SUBCATEGORY_CATALOG);

function buildFallbackOrderMap() {
  /** @type {Record<string, Record<string, string[]>>} */
  const out = { VN: {}, DEFAULT: {} };
  for (const cat of HUB_CATEGORY_IDS) {
    const order = getHubSubcategoryOrder(cat);
    out.VN[cat] = order;
    out.DEFAULT[cat] = order;
  }
  return out;
}

/** hub_config RPC 실패 시 — hubSubcategoryCatalog 기준 */
export const HUB_CONFIG_FALLBACK_ORDER = buildFallbackOrderMap();

/**
 * @param {string} category
 * @param {string} [countryCode]
 */
export function getFallbackSubcategoryOrder(category, countryCode = 'DEFAULT') {
  void countryCode;
  return getHubSubcategoryOrder(category) || [];
}
